<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="شكر-وتقدير">
<h1><span dir="rtl">شكر وتقدير</span></h1>
<p style="text-align: center;"><span dir="rtl">كل الشكر والتقدير للمدرِّسين في مراحل التعليم الأساسي، وللأُسرَة الكريمَة، ولكلِّ مَن ساهَمَ في نَشرِ هذا الكِتاب.</span></p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?e9cd50d2